import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  CreateCourse ({ state }, course) {
    let obj = course
    return new Promise((resolve, reject) => {
      axios.post('course/createCourse', obj)
        .then(response => {
          resolve(response.data)
          course = {}
        }).catch((err) => {
          reject(err)
        })
    })
  },
  updateCourse ({ state }, course) {
    let obj = course
    return new Promise((resolve, reject) => {
      axios.post('course/updateCourse', obj)
        .then(response => {
          resolve(response.data)
          course = {}
        }).catch((err) => {
          reject(err)
        })
    })
  },
  
  getcourselist ({ state, commit }) {
    axios.get('course/getcourselist')
      .then(response => {
        state.courseList = response.data
        commit('setCourseList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getCourseTypeList ({ state, commit }) {
    axios.get('course/getCourseTypeList')
      .then(response => {
        state.courseTypeList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  }
}
